import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../api";

export const doGetAllDrivers = createAsyncThunk("drivers/getAllDrivers", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.getAllDrivers(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateDriver = createAsyncThunk("drivers/doCreateDriver", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doCreateDriver(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateDriver = createAsyncThunk("drivers/doUpdateDriver", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdateDriver(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDeleteDriver = createAsyncThunk("drivers/doDeleteDriver", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doDeleteDriver(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});
